// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Ug9X","header":"PatientQuestionnaire_header__25agT","info":"PatientQuestionnaire_info__1FQ1n"};